export default __webpack_public_path__ + "static/media/load-simbolo-sic.0b5361b5.svg";